import { Box } from '@mui/material';
import React from 'react';
import { UserQuestionBubble } from './UserQuestionBubble';
import { AIResponseBubble } from './AIResponseBubble';
import { type SessionMessageType, type SessionType } from '../Chatbot';

interface ChatLogProps {
  session: SessionType | null;
  messageRefs: React.MutableRefObject<Record<string, HTMLDivElement | null>>;
  activeMessageId: string | null;
}

export const ChatLog: React.FC<ChatLogProps> = ({
  session,
  messageRefs,
  activeMessageId,
}) => {
  if (!session) return null;

  return (
    <>
      {session.messages.map((msg: SessionMessageType) => (
        <Box
          key={msg.messageId}
          data-message-id={msg.messageId}
          ref={(el) => {
            messageRefs.current[msg.messageId] = el as HTMLDivElement | null;
          }}
        >
          {msg.role === 'user' ? (
            <UserQuestionBubble
              message={msg.content.data}
              isHighlight={msg.messageId === activeMessageId}
            />
          ) : (
            <AIResponseBubble
              message={msg.content.data}
              navigatePath={msg.content.navigationPath}
              loading={msg.loading}
              image={msg.content.image}
              inspectionImages={msg.content.inspectionImages}
              report={msg.content.report}
            />
          )}
        </Box>
      ))}
    </>
  );
};
